<div class="tab-list-header">
    <div class="content-wrapper">
        <a
            class="tab-list-item active"
            [class.active]="isActiveTab(PROFILE)"
            [routerLink]="[profileLink]"
        >
            <span>{{ "SETTING.PROFILE" | translate }}</span>
        </a>
    </div>
</div>

<router-outlet></router-outlet>
